const locale = {
  DASHBOARDS: 'Dashboards',
  INVENTORY: 'Inventory',
  STORE: 'Store',
  BOOKING: 'Booking',
  SETTINGS: 'Settings',
  PATRONS: 'Patrons',
  CARDS: 'Cards',
  USER_ACCOUNTS: 'User Accounts',
  FOOD_VENDORS: 'Food Vendors',
};

export default locale;
